export default "__VITE_ASSET__02eXi2MN__"